<template>
  <div>
    <yw-head></yw-head>
    <div class="web-body">
      <div class="support">
        <my-banner :Mytype="'experience'"></my-banner>
        <div class="about">
          <div class="product-box">
            <div class="about-title">技术服务支持</div>
            <div class="about-text"> 如果您有任何问题，您可以留言或将问题发送到我们的电子邮件地址。</div>
            <div class="about-text"> 我们会在第一时间处理及给您答复。</div>
            <div class="about-text"> Email地址: bryan@yongwangkeji.cn</div>
            <div class="about-text"> 谢谢</div>
          </div>
          <div class="product-box">
            <div class="about-title "> Technical service support</div>
            <div class="about-text"> If you have any questions, you can either leave a message or send the questions to
              our email address.
            </div>
            <div class="about-text"> We will solve it as soon as possible.</div>
            <div class="about-text"> Email: bryan@yongwangkeji.cn</div>
            <div class="about-text"> thank you</div>
          </div>
        </div>

      </div>
    </div>
    <yw-footer></yw-footer>
  </div>
</template>

<script>
  import banner from './banner';
  import yw_head from './yw_head';
  import yw_footer from './yw_footer';

  export default {
    name: "support",
    components: {
      'my-banner': banner,
      'yw-head': yw_head,
      'yw-footer': yw_footer
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/support.vue